export default class AppState {
    hoverDistances = [] as number[];
}